export default "data:text/javascript;base64,aW1wb3J0IFROYXZEcm9wZG93biBmcm9tICIuL1ROYXZEcm9wZG93bi52dWUiOwoKZXhwb3J0IGRlZmF1bHQgVE5hdkRyb3Bkb3duOwo="